import React, { useEffect, useRef, useState } from 'react'
import { useMyContext } from '../../../components/Provider/CommonProvider'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Response_Processing from '../../../layout/Others/Response_Processing'
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput'
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch'
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'

const FooterAddUpdate = () => {
    const { id } = useParams()
    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/footer_menu/edit`
    const storeApi = `${baseURL}/admin/footer_menu/store`
    const updateApi = `${baseURL}/admin/footer_menu/update`
    const createApi = `${baseURL}/admin/footer_menu/create`

    const combinedRef = useRef({});
    const navigate = useNavigate()

    const { fetchRequest } = useMyContext()
    const [formDataError, setFormDataError] = useState({})
    const [formData, setFormData] = useState({ link: "site_url", });
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
    })


    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type == "text" || type === 'select-one') {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: value,
            }));
        }
        setFormDataError((prevFormData) => ({
            ...prevFormData,
            [name]: "",
        }));
    }

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Footer Name cannot be empty.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }
        else if (formData?.name?.length < 3) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Footer name mininum 3 letter.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }
        if (!formData?.link) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                link: "Select url type",
            }));
            combinedRef.current['link'].focus()
            formIsValid = false;
        }
        if (formData?.link == "site_url" && !formData?.select_url) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                select_url: "Site url cannot be empty.",
            }));
            combinedRef.current['select_url'].focus()
            formIsValid = false;
        }
        if (formData?.link == "custom_url" && !formData?.custom_url) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                custom_url: "Custom url cannot be empty.",
            }));
            combinedRef.current['custom_url'].focus()
            formIsValid = false;
        }

        if (!formData?.column_position) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                column_position: "Choose one of column",
            }));
            combinedRef.current['column_position'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "link", "column_position", "active", "select_url", "custom_url"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                setWithOutRefresh(!withOutRefresh)
                toast.success(result?.message)
                navigate("/footermenu")
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false);
        }
    }


    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "link", "column_position", "active", "select_url", "custom_url"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'PATCH',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }
    const handleStore = (e) => {
        e.preventDefault()
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
    }


    useEffect(async () => {

        if (id) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setFormData((prev) => ({
                            ...prev,
                            ...response?.data,
                        }));
                        setDefaultOption((prev) => ({
                            ...prev,
                            columnOption: response.footerMenuColumn,
                        }))
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
        else {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${createApi}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setDefaultOption((prev) => ({
                            ...prev,
                            columnOption: response.columns,
                        }))
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
    }, [withOutRefresh])
    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }


    return (
        <div>
            {showOverlay && <Response_Processing></Response_Processing>}
            {<AdminBackNavigation path={`${'/footermenu'}`} text="Back" />}
            <AdminSaveHeader heading={id ? "Edit Footer Menu" : "Add Footer Menu"} saveText={id ? "Update Footer Menu" : "Save Footer Menu"} saveMethod={handleStore} loading={showOverlay} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={id ? "Update Menu" : "Create Menu"} />
                        <MessageLabel text="Footer Menu Name" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Enter name"} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name} />
                        <MessageLabel text="Footer Menu URL" className="mandatorySimple" />
                        <AdminCustomSelect name="link" value={formData?.link} onChange={handleInput} ref={(el) => (combinedRef.current.link = el)} options={[{ name: "Site Url", value: "site_url" }, { name: "Custom Url", value: "custom_url" }]} error={formDataError?.link} defaultOptionName={""} />
                        {formData?.link == "site_url" &&
                            <>
                                <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                                <AdminCustomInput type="text" name="select_url" value={formData?.select_url} onChange={handleInput} placeHolder={"Enter site url"} ref={(el) => (combinedRef.current.select_url = el)} error={formDataError?.select_url} appendText={process.env.REACT_APP_Baseurl_Frontend} />
                            </>
                        }
                        {formData?.link == "custom_url" && <><MessageLabel text="Custom URL (ex. https || http)" className="mandatorySimple" />
                            <AdminCustomInput type="text" name="custom_url" value={formData?.custom_url} onChange={handleInput} placeHolder={"Enter custom url"} ref={(el) => (combinedRef.current.custom_url = el)} error={formDataError?.custom_url} />
                        </>}
                        {/* <AdminCustomInput type="text" name="link" value={formData?.link} onChange={handleInput} placeHolder={"Enter link"} ref={(el) => (combinedRef.current.link = el)} error={formDataError?.link} /> */}
                        <MessageLabel text="Choose  Column Position" className="mandatorySimple" />
                        <AdminCustomSelect name="column_position" value={formData?.column_position} onChange={handleInput} ref={(el) => (combinedRef.current.column_position = el)} options={defaultOption?.columnOption?.map((item) => ({ name: item?.column_name, value: item?.id }))} error={formDataError?.column_position} defaultOptionName={"Choose the footer column"} />
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={"Footer Menu Status Setting"} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Footer Menu Status"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                            </div>
                        </div>
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton saveMethod={handleStore} type="submit" saveText={id ? "Update Footer Menu" : "Save Footer Menu"} className="ms-auto" loading={showOverlay} />
            </FormContainer>
        </div>
    )
}
export default FooterAddUpdate